import { IApiUserGroupParams } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RootState } from 'store';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { fetchReferralPrograms } from 'modules/strapi/actions/fetchReferralPrograms';
import { web3Api } from 'store/queries';

import { filterBonusBundles } from '../utils/filterBonusBundles';

export interface ICheckDealDepositParams extends IApiUserGroupParams {
  from: number;
}

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be refelected there as well.
export const {
  endpoints: { checkDealDeposit },
  useCheckDealDepositQuery,
  useLazyCheckDealDepositQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    checkDealDeposit: build.query<boolean, ICheckDealDepositParams>({
      queryFn: createNotifyingQueryFn(async ({ from, group }, { getState }) => {
        const api = MultiService.getService().getAccountingGateway();

        const { bundles } = await api.getMyBundlesPaymentsHistory({
          from,
          group,
          limit: 2, // taking 2 to filter possible referral bonus bundle
        });

        const { data: referralPrograms } = fetchReferralPrograms.select()(
          getState() as RootState,
        );

        const isDepositMade =
          filterBonusBundles({
            bundles,
            referralPrograms,
          }).length > 0;

        return { data: isDepositMade };
      }),
    }),
  }),
});

export const {
  selectDataCachedByParams: selectIsDealDepositMade,
  selectLoadingCachedByParams: selectIsDealDepositMadeLoading,
  selectStateCachedByParams: selectIsDealDepositMadeState,
} = createQuerySelectors({ endpoint: checkDealDeposit });
